import { derivationsTemplate } from './derivation';
import { indicationsTemplate } from './indications';
import { educationalTemplate } from '@shared/templates/emails/educational';
import {
  examButtonCallPartial,
  examButtonDirectPartial,
  examButtonHeaderPartial,
  examButtonLinkPartial,
  examsImagesTeamTemplate,
  examsTemplate,
} from './exams';
import { pharmaciesSelectionPartial, pharmacyQuotePartial, recipeTemplate } from './recipe';
import { genericTemplate, genericTemplateCEM } from '@shared/templates/emails/generic';
import { surgeryTemplate } from './surgery';

export const mailTemplates = {
  generic: genericTemplate,
  genericCEM: genericTemplateCEM,
  surgery: surgeryTemplate,
  recipe: recipeTemplate,
  derivations: derivationsTemplate,
  indications: indicationsTemplate,
  exams: examsTemplate,
  examsImagesTeam: examsImagesTeamTemplate,
  educational: educationalTemplate,
};

export const mailPartialTemplates = {
  pharmacyQuote: pharmacyQuotePartial,
  pharmaciesSelection: pharmaciesSelectionPartial,
  examButtonDirect: examButtonDirectPartial,
  examButtonLink: examButtonLinkPartial,
  examButtonCall: examButtonCallPartial,
  examButtonHeader: examButtonHeaderPartial,

};
